 import Vuex from 'vuex';

export const store = new Vuex.Store({
  state: {
    shippingOptions: {
      selectedOption: 'instore',
      deliveryOption: false,
    },
    shippingAddress: {
      fullName: '',
      streetAddress: '',
      streetAddress2: '',
      city: '',
      state: '',
      zipcode: '',
      phone: ''
    },
    tax: null,
    tax_transaction_code: null
  },
  getters: {
    shippingAndHandling: state => {
      console.log('shipping option', state.shippingOptions.selectedOption);
      console.log('delivery option', state.shippingOptions.deliveryOption);
      if (state.shippingOptions.selectedOption == 'instore') return 0;
      if (state.shippingOptions.selectedOption == 'delivery') { 
        if (state.shippingOptions.deliveryOption == 'deliveryonly') return state.localDeliveryFee;
        if (state.shippingOptions.deliveryOption == 'deliveryandinstallation') return state.localDeliveryPlusInstallationFee;
      }
      if (state.shippingOptions.selectedOptions == 'shipping') {
        return 1000.00;
      } 
      return 0;
    },
    shouldShowProduct: (state) => (item) => {
      return (
        !state.shippingOptions.selectedOption == 'delivery' ||
        (state.shippingOptions.selectedOption == 'delivery' &&
          !state.upsellItems.some((x) => x[0].id == item.id))
        
        // !this.isInstallation ||
        // (this.isInstallation &&
        //   !this.upsellItems.some((x) => x[0].id == item.id))
      );
    },
    cartTax: (state) => {
      var subtotal = parseFloat(
        this.cartTotalAfterPromoCodeDiscount
      );
      // var shipping = parseFloat(this.cartShippingHandling);
      // if (
      // 	this.includeShipping &&
      // 	this.cartSubtotal >= this.min_delivery_amount
      // ) {
      // 	subtotal += shipping;
      // }
      let tax =0;
      if (this.shippingTaxRate) {
        tax = subtotal * parseFloat(this.shippingTaxRate);
      } else {
        tax = subtotal * this.taxRate;
      }
      return tax.toFixed(2);
    },
  },
  mutations: {

  },
  actions: {
    
  }
});
